<template>
  <h1>Depositing to WSB</h1>
  <p>
    You can deposit money on your wallet. It's Easy!<br>
    Select your deposit method.<br>
    <a v-if="username">User: {{ username }}</a> 
  </p>
  <p><strong>Up to 6% Real Money Bonus on all Deposits!</strong></p>
  
  <DepositMethodsGrid
    :username="username"
    @method-selected="handleMethodSelected"
    @info-requested="handleInfoRequested"
  />
</template>

<script>
import common from '@/scripts/common.js';
import DepositMethodsGrid from '@/components/DepositMethodsGridLesotho.vue';

export default {
  components: {
    DepositMethodsGrid
  },
  data() {
    return {
      username: this.$route.query.username || "", // Obtener el parámetro de la URL
      amount: null,
      showError: false,
      responseMessage: "",  // Mensaje de la respuesta
      responseType: "",     // Tipo de mensaje (exito / error)
      showDepositForm: true, // Controla la visibilidad del formulario de depósito
      isLoading: false,      // Controla si la solicitud está en proceso
    };
  },
  methods: { 
    handleMethodSelected(methodName) {
      const methodHandlers = {
        'vodacom': this.pagarVodacom,
        'ecocash': this.pagarEcocash,
        'nedbank': this.pagarNedbank,
        'mywallet': this.pagarMywallet,
        'vodacom-merchant': this.pagarVodacomMerchant,
        'ottvoucher': this.pagarOttVoucher,
        'help': this.pagarHelpContact
      };

      const handler = methodHandlers[methodName];
      if (handler) {
        handler();
      }
    },

    handleInfoRequested(methodName) {
      const infoHandlers = {
        'vodacom': this.infoVodacomPmesa,
        'ecocash': this.pagarEcocash,
        'nedbank': this.infoNedbank,
        'mywallet': this.infoMywallet,
        'vodacom-merchant': this.pagarVodacomMerchant,
        'ottvoucher': this.infoOttVoucher
      };

      const handler = infoHandlers[methodName];
      if (handler) {
        handler();
      }
    },

    infoVodacomPmesa() {
      window.parent.postMessage({ action: 'btnVodacomInstam' }, '*');
    },

    infoNedbank() {
      window.parent.postMessage({ action: 'btnNedbank' }, '*');
    },

    infoMywallet() {
      window.parent.postMessage({ action: 'btnMywalletInfo' }, '*');
    },

    infoOttVoucher() {
      window.parent.postMessage({ action: 'btnOttVoucherInfo' }, '*');
    },
  
    pagarVodacomMerchant() {
      window.parent.postMessage({ action: 'btnReferenceVodacom' }, '*');
    },

    pagarEcocash() {
      window.parent.postMessage({ action: 'btnReferenceEco' }, '*');
    },

    async pagarOttVoucher() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con OTT Voucher...");

        var maintenance = await common.checkMaintenanceLS("ottvoucher");

        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceLesotho', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'OttvoucherDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    pagarHelpContact() {
      window.parent.postMessage({ action: 'btnHelpContact' }, '*');
    },

    async pagarMywallet() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con MyWallet...");

        var maintenance = await common.checkMaintenanceLS("mywallet");
        
        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceLesotho', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'MywalletDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarVodacom() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con Vodacom...");

        var maintenance = await common.checkMaintenanceLS("vodacom");
        
        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceLesotho', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'VodacomDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    async pagarNedbank() {
      if (!this.username) {
        window.parent.postMessage({ action: 'btnLogin' }, '*');
      } else {
        window.parent.postMessage({ action: 'btnhiddeninfo' }, '*');
        console.log("Iniciando pago con Nedbank...");
        var maintenance = await common.checkMaintenanceLS("nedbank");
          
        if (maintenance) {
          this.$router.push({ name: 'DepositMaintenanceLesotho', query: { username: this.$route.query.username } });
        } else {
          this.$router.push({ name: 'NedbankDepositWebsite', query: { username: this.$route.query.username } });
        }
      }
    },

    sendHeight() {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ iframeHeight: height }, "*");
    }
  },

  mounted() {
    // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  }
  
};
</script>

<style scoped>
body {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 {
  color: #1a2332;
  text-align: center;
  font-weight: 800;
  padding: 25px 15px;
  font-size: 32px;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

p {
  color: #555;
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  margin: 10px 0;
}

p a {
  color: #1a73e8;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

p a:hover {
  color: #1557b0;
  text-decoration: underline;
}

p strong {
  color: #000000;
  font-weight: 700;
}
</style>
